import React, {useEffect, useState} from 'react';
import ReservationMaterialEstimateUnitTable
    from "../../../../components/UI/table/warehouse/reservation/ReservationMaterialEstimateUnitTable";
import {useLocation, useParams} from "react-router-dom";
import MaterialReserveService from "../../../../API/orders/reservation/MaterialReserveService";
import {constantsErrorMessages} from "../../../../Constants";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";

const IssuanceReservationMaterialEstimateUnit = () => {
    const [alertData, setAlertData] = useState({});
    const [data, setData] = useState([]);
    const [change, setChange] = useState(false);
    const params = useParams();
    const materialEstimateUnitId = params.eId;
    const orderId = params.orderId;
    const orderNumber = params.orderNumber;
    const type = params.type
    const nameMaterial = params.nameMaterial
    const baseUnit = params.type

    const pathname = useLocation().pathname
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    const [unablePackaging, setUnablePackaging] = useState({});
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    useEffect(() => {
        getStartPageSize()
        MaterialReserveService.getAllByMaterialEstimateUnitId(type, materialEstimateUnitId).then(function (response) {
            const data = response.data;
            data.forEach((row) => {
                unablePackaging[row.id] = row.packaging;
            });
            setData(data);
            setTableOptions((prev) => ({...prev, totalElements: response.data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [change]);

    const handleUnableCheckboxPackaging = (id, status) => {
        MaterialReserveService.setPackaging(id, status).then(function () {
            handleUnableTurn(id, status);
            handleModalAlert("Данные изменены", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    };

    const handleUnableTurn = (id, status) => {
        unablePackaging[id] = status
        setUnablePackaging(prevState => ({
            ...prevState,
            [id]: status
        }));
    };

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Резервы"}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Выдача штучных материалов", href: "/organization/issuance-piece-materials"},
                    {
                        name: `Выдача штучных материалов заказа: ${params.orderNumber}`,
                        href: `/organization/issuance-piece-materials/${params.orderId}/${encodeURIComponent(params.orderNumber)}`
                    },
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Резервы
                    </Typography>
                </Box>
                <ReservationMaterialEstimateUnitTable
                    data={data}
                    setData={setData}
                    orderId={orderId}
                    nameOrder={orderNumber}
                    isButtonPurchase={false}
                    isSlab={false}
                    isColumnOrder={false}
                    isIssue={true}
                    unablePackaging={unablePackaging}
                    setUnablePackaging={handleUnableCheckboxPackaging}
                    handleModalAlert={handleModalAlert}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    isPackaging={true}
                    materialEstimateUnitId={materialEstimateUnitId}
                    isPieceMaterials={true}
                    typeMaterial={type}
                    nameMaterial={nameMaterial}
                    baseUnit={baseUnit}
                />
            </Box>
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
        </Box>
    );
};

export default IssuanceReservationMaterialEstimateUnit;